var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWpml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.531,
    y1: 22.766,
    x2: 25.042,
    y2: 28.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33879e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#726c68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#8e6051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#a4573f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#b55030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#c04b26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#c74821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9471f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_wpml") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.09,2C10.15,2.013,4.178,7.74,4.245,13.788c-.011,5.97,4.739,11.236,11.868,11.552,4.047.177,5.532-1.865,7.23-1.414s1.874,1.945,1.788,3.085a2.353,2.353,0,0,1-2.5,2.338c-.988-.5-.391-3.2-1.906-3.36-.946.1-1.368.93-1.159,1.946S21.082,29.923,22.949,30a2.888,2.888,0,0,0,2.987-3.006,3.284,3.284,0,0,0-2.809-3.516c-1.913-.178-4.337,2.139-7.957,1.473A10.506,10.506,0,0,1,6.446,14.261c.03-6.9,6.429-10.254,10.452-10.217s6.144,1.4,6.759,3.693-2.031,4.616-3.223,5.973-1.822,2.266-1.572,3.851c.251,1.663,2.162,4.1,4.166,4.087s4.919-2.255,4.716-7.7a11.993,11.993,0,0,0-4.558-9.353C21.752,3.456,20.032,1.989,15.09,2Z",
    style: {
      fill: "url(#a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpml);
export default __webpack_public_path__ + "static/media/wpml.743a6b41f58fa7b7625521225ba0e510.svg";
export { ForwardRef as ReactComponent };